import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
} from "../../../shared";
import { Observable } from "rxjs";
import { JobContainerModel } from "../../../../../../../models/aggregates";

@Injectable({
  providedIn: "root",
})
export class CreateJobsFromGenDocService extends BaseApiTemplateService<JobContainerModel[]> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "del/jobs/create-job-doc/backoffice-ep";
    this.httpClient = http;
  }
}
